import { api } from "@/lib/api";
import { Region, RegionDtoSchema, regionFromDto, regionToDto } from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getRegionQueryOptions, getRegionsQueryOptions } from "./get.hooks";

export function useUpdateRegion(opts?: {
  onSuccess?: (region: Region) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (region: Region) => {
      const dto = regionToDto(region);
      const result = await api.put("/api/regions", dto, RegionDtoSchema);
      return regionFromDto(result);
    },
    onSuccess: (region) => {
      queryClient.setQueryData(getRegionsQueryOptions.queryKey, (old) =>
        old?.map((r) => (r.id === region.id ? region : r)),
      );
      queryClient.setQueryData(
        getRegionQueryOptions(region.id).queryKey,
        () => region,
      );
      toast({
        title: "toast.regionUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(region);
    },
    onError: () => {
      toast({
        title: "toast.updateRegionError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
